<template>
    <div id="CustomLutV2-edit-lut-modal" class="modal-new hidden">
        <svg class="btn-close-modal" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
            <path
                d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
            <path d="M0 0h24v24H0z" fill="none" />
        </svg>

        <div class="modal-title-container">
            <span class="title" @click="goBack">
                LUTs Management
            </span>
            <span v-if="!folderView">
                <v-icon class="material-icons" size="18" color="white">keyboard_arrow_right</v-icon>
                {{ selectedFolder.name }}
            </span>
        </div>


        <div class="modal-content-list-container mt-10">
            <template v-if="folderView">
                <span v-if="customLuts.length == 0" class="no-folders-message">You do not have any custom LUTs yet. Please click on the Create Folder button to create your first custom LUTs folder and import some LUTs. You can import LUTs in .cube format.</span>
                <div v-for="customLutFolder in customLuts" :key="customLutFolder.id"
                     @dblclick="selectFolder(customLutFolder)" class="custom-luts-folder">
                    <span class="custom-luts-folder__name">{{ customLutFolder.name }}</span>

                    <v-menu :content-class="'project-options-container'" offset-y>
                        <template v-slot:activator="{ on, attrs }">
                            <i class="material-icons" v-bind="attrs" v-on="on">
                                more_vert
                            </i>
                        </template>
                        <v-list>
                            <v-list-item @click="renameFolder(customLutFolder)">
                                <span class="option">Rename Folder</span>
                            </v-list-item>
                            <v-list-item @click="deleteFolder(customLutFolder)">
                                <span class="option">Delete Folder</span>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </div>
            </template>

            <template v-else>
                <div v-for="lut in selectedFolder.files" :key="lut.id" class="custom-luts-single">
                    <span class="custom-luts-single__name">{{ stripTimestampAndExtension(lut.name) }}</span>

                    <v-menu :content-class="'project-options-container'" offset-y>
                        <template v-slot:activator="{ on, attrs }">
                            <i class="material-icons" v-bind="attrs" v-on="on">
                                more_vert
                            </i>
                        </template>
                        <v-list>
                            <v-list-item @click="renameLut(lut)">
                                <span class="option">Rename LUT</span>
                            </v-list-item>
                            <v-list-item @click="deleteLut(lut)">
                                <span class="option">Delete LUT</span>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </div>
            </template>
        </div>

        <div class="buttons-continer mt-10">
            <v-btn v-if="folderView" dark class="modal-btn --primary" @click="createFolder">Create Folder
            </v-btn>
            <v-btn v-else dark class="modal-btn --primary" @click="importLuts">Import LUTs
            </v-btn>
            <button type="button" class="modal-btn --cancel" @click="close">Close</button>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import FilenameMixin from "@/mixins/Filename";

export default {
    mixins: [FilenameMixin],
    data() {
        return {
            folderView: true,
        }
    },

    computed: {
        ...mapState('UserFilesCustomLuts', {
            selectedFolder: 'folder',
            customLuts: 'customLuts',
        }),
    },
    methods: {
        selectFolder(folder) {
            this.folderView = false;
            this.$store.commit('UserFilesCustomLuts/SET_CUSTOM_LUTS_FOLDER', folder)
        },

        createFolder() {
            window.UI.hideModal();
            window.UI.showModal(window.UI.modals.customLutV2.createFolder.el);
        },

        renameFolder(folder) {
            this.$store.commit('UserFilesCustomLuts/SET_CUSTOM_LUTS_FOLDER', folder)
            window.UI.hideModal();
            window.UI.showModalWithoutClearing(window.UI.modals.customLutV2.renameFolder.el);
        },

        deleteFolder(folder) {
            this.$store.commit('UserFilesCustomLuts/SET_CUSTOM_LUTS_FOLDER', folder)
            window.UI.hideModal();
            window.UI.showModal(window.UI.modals.customLutV2.deleteFolder.el);
        },

        importLuts() {
            this.$root.CustomLutV2ImportInput.click();
        },

        deleteLut(lut) {
            this.$store.commit('UserFilesCustomLuts/SET_LUT_TO_DELETE', lut);
            window.UI.hideModal();
            window.UI.showModal(window.UI.modals.customLutV2.delete.el, window.UI.modals.customLutV2.edit.el);
        },

        renameLut(lut) {
            this.$store.commit('UserFilesCustomLuts/SET_LUT_TO_RENAME', lut);
            window.UI.hideModal();
            window.UI.showModalWithoutClearing(window.UI.modals.customLutV2.rename.el);
        },

        goBack() {
            this.folderView = true;
        },

        close() {
            window.UI.hideModal();
        }
    }
};
</script>

<style lang="scss" scoped>
.modal-new {
    width: 50%;

    .modal-title-container {
        width: 80%;
        overflow-x: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding-top: 20px;

        .title {
            padding-left: 20px;
            cursor: pointer;
            &:hover {
                color: var(--color-accent);
            }
        }
    }


    > .btn-close-modal {
        right: 43px;
        top: 40px;
    }
}

.modal-content-list-container {
    height: 350px;
    overflow-y: scroll;
    overflow-x: hidden;
    scrollbar-color: #989898 transparent;
    scrollbar-width: thin;

    &::-webkit-scrollbar {
        -webkit-appearance: none;
        width: 5px;
    }

    &::-webkit-scrollbar-thumb {
        border-radius: 4px;
        background-color: #989898;
    }

    .no-folders-message {
        display: flex;
        align-items: center;
        height: 100%;
        padding: 0 20px;
        line-height: 1.2;
        text-align: center;
    }
}

.custom-luts-folder,
.custom-luts-single {
    padding: 10px 20px;
    display: grid;
    grid-template-columns: 1fr 18px;
    grid-column-gap: 15px;
    align-items: center;
    cursor: pointer;
    border-radius: 10px;

    &.--selected,
    &:hover {
        background: #363636;
    }

    &__name {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        line-height: 1.2;
    }
}
</style>
